import React from 'react';

function SFAQ() {
  const faqs = [
    { question: "What languages does AWS Eloquence support?", answer: "Yes, we ship to many countries worldwide." },
    { question: "Is Feedback supported on other meeting applications other than Chime?", answer: "AWS Eloquence is only supported as a Chime add on." },
    { question: "What languages does AWS Eloquence support?", answer: "Yes, we ship to many countries worldwide." },
    { question: "Is Feedback supported on other meeting applications other than Chime?", answer: "AWS Eloquence is only supported as a Chime add on." },
    { question: "What languages does AWS Eloquence support?", answer: "Yes, we ship to many countries worldwide." },
    { question: "Is Feedback supported on other meeting applications other than Chime?", answer: "AWS Eloquence is only supported as a Chime add on." },

  ];

  return (
    <div>
      <h3>Stakeholder Frequently Asked Questions</h3>
      <ul>
        {faqs.map((faq, index) => (
          <li key={index}>
            <strong>{faq.question}</strong>
            <ul style={{ paddingLeft: '20px' }}>
              <li>{faq.answer}</li>
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default SFAQ;